export enum VariableRelation {
  PARENT = 'parent',
  CHILD = 'child',
  SELECTED = 'selected',
  NONE = 'none'
}
